// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5261":"c2a9a98c744885f8","6025":"08ea24834ca7a66a"}[chunkId] + ".js";
};